<div class="parent pb-1" #parent>
  <div #titlepart class="titlebar">
    @if (title || !hideSelectionInfo) {
      <div class="pb-2">
        <div class="title sentancify">{{ title }}</div>
        @if (!hideSelectionInfo) {
          <div class="subtitle">
            {{ selectedParticipantIds.length }} participant{{
              selectedParticipantIds.length === 1 ? "" : "s"
            }}
            selected
          </div>
        }
      </div>
    }
  </div>
  @if (participantsToShow && participantsToShow.length) {
    <div class="list_content">
      <div class="search_bar">
        <app-celo-topbar-search-input
          class="fw"
          [searchTerm]="''"
          [placeholder]="'Search'"
          [autoSearch]="false"
          [characterLimit]="false"
          (doSearch)="filter($event)"
        >
        </app-celo-topbar-search-input>
      </div>
      <ul #chipList>
        @for (participant of participantsToShow; track participant) {
          <li
            matRipple
            (click)="pickParticipant(participant)"
            class="chip celo-hoverable"
          >
            <div class="selector">
              @if (selectedParticipantIds.indexOf(participant.userId) === -1) {
                <i class="material-icons">check_box_outline_blank</i>
              }
              @if (selectedParticipantIds.indexOf(participant.userId) !== -1) {
                <i class="material-icons selected">check_box</i>
              }
            </div>
            <div class="icon">
              <app-avatar
                [name]="participant.firstName + ' ' + participant.lastName"
                [userId]="participant.userId"
                [width]="40"
                [height]="40"
                [hasImage]="!!participant.profilePic"
                [picUrl]="participant.profilePic"
                [showBadge]="showBadge"
                [badgeSize]="18"
                [workspaces]="participant.workplaces"
                [identityVerificationStatus]="
                  participant.identityVerificationStatus
                "
                [showTooltip]="false"
                [user]="participant"
              ></app-avatar>
            </div>
            <div class="texts fw block">
              <div class="name celo-elipsis">
                {{ participant.firstName }} {{ participant.lastName }}
              </div>
              @if (
                !hideProfession &&
                participant.professions[0] &&
                participant.professions[0].category &&
                participant.professions[0].verificationStatus === "Verified"
              ) {
                <div class="subtitle-text">
                  {{ participant.professions[0].profession }}
                </div>
              }
            </div>
            <button
              mat-icon-button
              class="info_button"
              (click)="
                $event.stopPropagation(); preview.emit(participant.userId)
              "
            >
              <mat-icon svgIcon="icon-info" class="icon-xl"></mat-icon>
            </button>
          </li>
        }
        <div #bottom id="bottom"></div>
      </ul>
    </div>
  }
  @if (!participantsToShow.length) {
    <div class="ro_results_window">
      <div class="no_results appear_1">{{ noResultsMessage }}</div>
    </div>
  }
</div>
